import { IColumnConfig } from 'v2/modules/shared/interfaces/table.interface';

export const RfqTableColumnConfig :IColumnConfig[] = [
  {
    id: 'sku',
    label: 'SKU',
    visible: true,
  },
  {
    id: 'product_name',
    label: 'Product Name',
    visible: true,
  },
  {
    id: 'description',
    label: 'Description',
    visible: true,
  },
  {
    id: 'category',
    label: 'Category',
    visible: false,
  },
  {
    id: 'sub_category',
    label: 'Sub Category',
    visible: false,
  },
  {
    id: 'stock',
    label: 'Stock',
    visible: true,
  },
  {
    id: 'quantity',
    label: 'Qty',
    visible: true,
  },
  {
    id: 'unit',
    label: 'Unit',
    visible: true,
  },
  {
    id: 'unit_price',
    label: 'Unit Price',
    visible: true,
  },
  {
    id: 'line_total',
    label: 'Line Total',
    visible: true,
  },
];

export const RfqTableSalesOrderColumnConfig :IColumnConfig[] = [
  ...RfqTableColumnConfig.map((column :IColumnConfig) :IColumnConfig => {
    switch (column.id) {
      // hide by default
      case 'description':
        return { ...column, visible: false };
      // make no change
      default:
        return column;
    }
  }),
  {
    id: 'estimated_ship_date',
    label: 'Estimated Ship Date',
    visible: true,
  },
  {
    id: 'line_item_status',
    label: 'Status',
    visible: true,
  },
  {
    id: 'original_quantity_ordered',
    label: 'Original Qty',
    visible: false,
  },
];
